import { useSearchParams } from 'react-router-dom'

/**
 * Get organization IDs and season from URL params
 * @returns {{ farmId: string | null, plotId: string | null, patchId: string | null, seasonId: string | null }}
 */
export const useOrgParams = () => {
  const [searchParams] = useSearchParams()
  return {
    farmId: searchParams.get('farmId'),
    plotId: searchParams.get('plotId'),
    patchId: searchParams.get('patchId'),
    seasonId: searchParams.get('seasonId'),
  }
}
